import { Injectable } from '@angular/core';
import { IssueStateStore } from './issueState.store';
import { BaseEntityStoreStrategy } from '../updateStoreStrategies';
import { IssueStateQuery } from './issueState.query';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { IIssueState } from '@common/interfaces/issueState';
import { Topics } from '@common/interfaces/topics';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IssueStateService extends CrudService<IIssueState, IssueStateStore, IssueStateQuery> {

  markAsRead$: Subject<boolean> = new Subject();

  constructor(
    public store: IssueStateStore,
    public query: IssueStateQuery,
    protected updateStrategy: BaseEntityStoreStrategy,
    protected actionService: ActionService) {
    super(
      Topics.ISSUE_STATES,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

  }
